import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderOrg = () => (
    <header className="HeaderOrg">
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Organization header bar with admin navigation">
            <div className="container w-max2">
                <h5 className="sp-mx" id="organizations-header-title">
                    <i className="bi bi-building" aria-hidden="true"></i>
                    <span className="sp-margin12">Organizations</span>
                </h5>
                {/*Admin Menus*/}
                <NavAdmin />
            </div>
        </nav>
    </header>
);


export default HeaderOrg;
